<template>
  <section id="search-results-container">
    <ul
      :class="{
        active: productQuery.length >= 3,
      }"
      tabindex="0"
    >
      <li v-if="loading" class="result-card" tabindex="0">
        <span>Loading ...</span>
      </li>

      <template
        v-else-if="!products.length && productQuery.length >= 3 && !loading"
      >
        <li class="result-card inactive"><span>No results</span></li>
      </template>

      <template v-else>
        <SearchResultsItem
          v-for="product in products"
          :key="product.id + '-result'"
          :product="product"
          :activePageItem="activePageItem"
          v-on="{ onSelectedProduct: emitCloseModal }"
        />
      </template>
    </ul>
  </section>
</template>

<script>
import SearchResultsItem from "@/components/Projects/Snapsheets/SearchResultsItem.vue";
export default {
  name: "SearchResults",
  components: { SearchResultsItem },
  props: {
    productQuery: {
      type: String,
    },
    activePageItem: {
      type: Object,
    },
    products: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    order: {
      type: Number,
    },
    originalLogoImage: {},
    screenLogo: {},
  },

  methods: {
    emitCloseModal() {
      this.$emit("onSelectedProduct");
    },
  },
};
</script>

<style lang="scss" scoped>
#search-results-container {
  display: flex;
  flex-direction: column;

  ul {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 200px;
    width: 100%;
    transform: scaleY(0);
    transform-origin: top;
    transition: all 0.2s;
    border: none;
    overflow-y: auto;

    &.active {
      transform: scale(1);
    }

    @media screen and (max-width: 768px) {
      max-height: 350px;
    }
  }

  ::v-deep .result-card {
    display: flex;
    align-items: center;
    padding: 0.8rem 1.5rem;
    background: $grey-lightest;
    cursor: pointer;
    text-align: center;
    transition: all 0.15s;

    &:nth-child(odd) {
      background-color: white;
    }

    &:not(.inactive):hover {
      background-color: #059c370d;
      .alias{
        color: $green;
      }
    }

    p:first-child {
      font-weight: bold;
      margin-right: 1rem;
    }

    &.inactive {
      background: rgb(187, 187, 187);
      box-shadow: initial;
      cursor: not-allowed;

      p {
        color: white;
      }

      p:last-child {
        font-size: 0.7rem;
        margin-left: auto;
      }
    }
  }
}
</style>